// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Maximal Dealer Portal - Design System */

/* ========================================
   CSS VARIABLES
   ======================================== */

:root {
  /* Primary - Maximal Red */
  --color-primary: #E31837;
  --color-primary-hover: #C41530;
  --color-primary-light: #FEE2E2;

  /* Admin/Secondary - Purple */
  --color-admin: #6366F1;
  --color-admin-hover: #4F46E5;
  --color-admin-light: #EEF2FF;

  /* Neutrals */
  --color-white: #FFFFFF;
  --color-gray-50: #F9FAFB;
  --color-gray-100: #F3F4F6;
  --color-gray-200: #E5E7EB;
  --color-gray-300: #D1D5DB;
  --color-gray-400: #9CA3AF;
  --color-gray-500: #6B7280;
  --color-gray-600: #4B5563;
  --color-gray-700: #374151;
  --color-gray-800: #1F2937;
  --color-gray-900: #111827;

  /* Status Colors */
  --color-success: #166534;
  --color-success-bg: #DCFCE7;
  --color-warning: #92400E;
  --color-warning-bg: #FEF3C7;
  --color-info: #1D4ED8;
  --color-info-bg: #DBEAFE;
  --color-error: #991B1B;
  --color-error-bg: #FEE2E2;

  /* Engine Type Badge Colors */
  --badge-electric-bg: #DCFCE7;
  --badge-electric-text: #166534;
  --badge-diesel-bg: #F3F4F6;
  --badge-diesel-text: #4B5563;
  --badge-lpg-bg: #FEF3C7;
  --badge-lpg-text: #92400E;
  --badge-rough-terrain-bg: #F3E8FF;
  --badge-rough-terrain-text: #7C3AED;
  --badge-reach-bg: #DBEAFE;
  --badge-reach-text: #1D4ED8;
  --badge-warehouse-bg: #FCE7F3;
  --badge-warehouse-text: #BE185D;

  /* Typography */
  --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  
  /* Spacing */
  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 1.5rem;
  --spacing-xl: 2rem;
  --spacing-2xl: 3rem;

  /* Borders */
  --border-radius-sm: 0.375rem;
  --border-radius-md: 0.5rem;
  --border-radius-lg: 0.75rem;
  --border-radius-xl: 1rem;
  
  /* Shadows */
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
  --shadow-primary: 0 4px 12px rgba(227, 24, 55, 0.15);
  --shadow-admin: 0 4px 12px rgba(99, 102, 241, 0.15);
}

/* ========================================
   BASE STYLES
   ======================================== */

* {
  box-sizing: border-box;
}

body {
  font-family: var(--font-family);
  color: var(--color-gray-800);
  background-color: var(--color-gray-50);
  line-height: 1.5;
  margin: 0;
  padding: 0;
}

/* ========================================
   LAYOUT
   ======================================== */

.page-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--color-gray-50);
}

.main-content {
  flex: 1 1;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: var(--spacing-xl) var(--spacing-lg);
}

.main-content-wide {
  flex: 1 1;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: var(--spacing-xl) var(--spacing-lg);
}

/* ========================================
   HEADER
   ======================================== */

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-md) var(--spacing-lg);
  background-color: var(--color-white);
  border-bottom: 1px solid var(--color-gray-200);
  box-shadow: var(--shadow-sm);
}

.header-logo {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  text-decoration: none;
  color: inherit;
}

.header-logo-text {
  display: flex;
  flex-direction: column;
}

.header-logo-title {
  color: var(--color-gray-800);
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.2;
  letter-spacing: -0.01em;
}

.header-logo-subtitle {
  color: var(--color-gray-500);
  font-size: 0.75rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.header-nav {
  display: flex;
  align-items: center;
  gap: var(--spacing-lg);
}

.header-link {
  color: var(--color-gray-500);
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.2s;
}

.header-link:hover {
  color: var(--color-gray-900);
}

.header-user {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

.header-user-info {
  text-align: right;
}

.header-user-name {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-gray-800);
  margin: 0;
}

.header-user-role {
  font-size: 0.75rem;
  color: var(--color-primary);
  font-weight: 500;
  margin: 0;
}

.header-user-role.admin {
  color: var(--color-admin);
}

.header-avatar {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  background-color: var(--color-primary);
  color: var(--color-white);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
}

/* ========================================
   SUB-HEADER / TABS
   ======================================== */

.sub-header {
  background-color: var(--color-white);
  border-bottom: 1px solid var(--color-gray-200);
  padding: 0 var(--spacing-lg);
}

.tab-nav {
  display: flex;
  gap: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
}

.tab-link {
  padding: var(--spacing-md) var(--spacing-sm);
  color: var(--color-gray-600);
  text-decoration: none;
  font-weight: 500;
  font-size: 0.875rem;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}

.tab-link:hover {
  color: var(--color-gray-900);
  border-bottom-color: var(--color-gray-300);
}

.tab-link.active {
  color: var(--color-primary);
  border-bottom-color: var(--color-primary);
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xs);
  color: var(--color-gray-600);
  text-decoration: none;
  font-size: 0.875rem;
  margin-bottom: var(--spacing-md);
  transition: color 0.2s;
}

.back-link:hover {
  color: var(--color-primary);
}

/* ========================================
   FOOTER
   ======================================== */

.footer {
  background-color: var(--color-white);
  border-top: 1px solid var(--color-gray-200);
  padding: var(--spacing-lg);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer-text {
  color: var(--color-gray-500);
  font-size: 0.875rem;
}

.footer-link {
  color: var(--color-gray-500);
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.2s;
}

.footer-link:hover {
  color: var(--color-gray-900);
}

/* ========================================
   CARDS
   ======================================== */

.card {
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-200);
  border-radius: var(--border-radius-xl);
  padding: var(--spacing-lg);
  box-shadow: var(--shadow-sm);
  transition: all 0.2s;
}

.card:hover {
  box-shadow: var(--shadow-md);
}

.card.tile {
  display: block;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.card.tile:hover {
  border-color: var(--color-primary);
  box-shadow: var(--shadow-primary);
  transform: translateY(-2px);
}

.card-admin.tile:hover {
  border-color: var(--color-admin);
  box-shadow: var(--shadow-admin);
}

/* ========================================
   TILES (Dashboard)
   ======================================== */

.tile-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: var(--spacing-md);
}

.tile-icon {
  width: 3rem;
  height: 3rem;
  border-radius: var(--border-radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary);
  background-color: var(--color-primary-light);
}

.tile-icon.primary {
  color: var(--color-primary);
  background-color: var(--color-primary-light);
}

.tile-icon.admin {
  color: var(--color-admin);
  background-color: var(--color-admin-light);
}

.tile-icon svg {
  width: 1.75rem;
  height: 1.75rem;
}

.tile-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-gray-800);
  margin: 0 0 var(--spacing-xs) 0;
  transition: color 0.2s;
}

.card.tile:hover .tile-title {
  color: var(--color-primary);
}

.card-admin.tile:hover .tile-title {
  color: var(--color-admin);
}

.tile-description {
  font-size: 0.875rem;
  color: var(--color-gray-600);
  margin: 0 0 var(--spacing-md) 0;
  line-height: 1.5;
}

.tile-footer {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-primary);
}

.tile-footer svg {
  width: 1rem;
  height: 1rem;
}

/* ========================================
   BADGES
   ======================================== */

.badge {
  display: inline-block;
  padding: 0.25rem 0.625rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
}

.badge-success {
  background-color: var(--color-success-bg);
  color: var(--color-success);
}

.badge-warning {
  background-color: var(--color-warning-bg);
  color: var(--color-warning);
}

.badge-info {
  background-color: var(--color-info-bg);
  color: var(--color-info);
}

.badge-error {
  background-color: var(--color-error-bg);
  color: var(--color-error);
}

.badge-purple {
  background-color: #F3E8FF;
  color: #7C3AED;
}

.badge-pink {
  background-color: #FCE7F3;
  color: #BE185D;
}

.badge-gray {
  background-color: var(--color-gray-100);
  color: var(--color-gray-700);
}

/* Engine Type Badges */
.badge-electric {
  background-color: var(--badge-electric-bg);
  color: var(--badge-electric-text);
}

.badge-diesel {
  background-color: var(--badge-diesel-bg);
  color: var(--badge-diesel-text);
}

.badge-lpg {
  background-color: var(--badge-lpg-bg);
  color: var(--badge-lpg-text);
}

.badge-rough-terrain {
  background-color: var(--badge-rough-terrain-bg);
  color: var(--badge-rough-terrain-text);
}

.badge-reach {
  background-color: var(--badge-reach-bg);
  color: var(--badge-reach-text);
}

.badge-warehouse {
  background-color: var(--badge-warehouse-bg);
  color: var(--badge-warehouse-text);
}

/* ========================================
   BUTTONS
   ======================================== */

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-xs);
  padding: 0.625rem 1.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
  border-radius: var(--border-radius-md);
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-color: var(--color-primary);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--color-primary-hover);
  border-color: var(--color-primary-hover);
}

.btn-secondary {
  background-color: var(--color-white);
  color: var(--color-gray-700);
  border-color: var(--color-gray-300);
}

.btn-secondary:hover:not(:disabled) {
  background-color: var(--color-gray-50);
  border-color: var(--color-gray-400);
}

.btn-ghost {
  background-color: transparent;
  color: var(--color-gray-600);
  border-color: transparent;
}

.btn-ghost:hover:not(:disabled) {
  background-color: var(--color-gray-100);
  color: var(--color-gray-900);
}

.btn-admin {
  background-color: var(--color-admin);
  color: var(--color-white);
  border-color: var(--color-admin);
}

.btn-admin:hover:not(:disabled) {
  background-color: var(--color-admin-hover);
  border-color: var(--color-admin-hover);
}

.btn-icon {
  padding: 0.5rem;
  border-radius: var(--border-radius-md);
}

/* ========================================
   FORMS
   ======================================== */

.form-group {
  margin-bottom: var(--spacing-lg);
}

.form-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--color-gray-700);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: var(--spacing-xs);
}

.form-input,
.form-select,
.form-textarea {
  width: 100%;
  padding: 0.625rem 0.875rem;
  font-size: 0.875rem;
  color: var(--color-gray-800);
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-300);
  border-radius: var(--border-radius-md);
  transition: border-color 0.2s;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  outline: none;
  border-color: var(--color-primary);
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

.form-error {
  color: var(--color-error);
  font-size: 0.75rem;
  margin-top: var(--spacing-xs);
}

/* ========================================
   GRID LAYOUTS
   ======================================== */

.grid-2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--spacing-lg);
}

.grid-3 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-lg);
}

.grid-4 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: var(--spacing-lg);
}

.grid-6 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: var(--spacing-md);
}

@media (min-width: 768px) {
  .grid-2 {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .grid-3 {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .grid-4 {
    grid-template-columns: repeat(4, 1fr);
  }
  
  .grid-6 {
    grid-template-columns: repeat(6, 1fr);
  }
}

/* ========================================
   ACCORDION (Forklift Ranges)
   ======================================== */

.accordion {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.accordion-item {
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-200);
  border-radius: var(--border-radius-lg);
  overflow: hidden;
}

.accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-md) var(--spacing-lg);
  background-color: var(--color-gray-50);
  cursor: pointer;
  transition: background-color 0.2s;
  border: none;
  width: 100%;
  text-align: left;
}

.accordion-header:hover {
  background-color: var(--color-gray-100);
}

.accordion-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-gray-800);
  margin: 0;
}

.accordion-icon {
  width: 1.25rem;
  height: 1.25rem;
  color: var(--color-gray-500);
  transition: transform 0.2s;
}

.accordion-header.expanded .accordion-icon {
  transform: rotate(180deg);
}

.accordion-content {
  padding: var(--spacing-lg);
}

.accordion-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-md);
  border-bottom: 1px solid var(--color-gray-100);
}

.accordion-row:last-child {
  border-bottom: none;
}

.accordion-model-info {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

.accordion-model-name {
  font-weight: 600;
  color: var(--color-gray-800);
}

.accordion-model-specs {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  color: var(--color-gray-600);
  font-size: 0.875rem;
}

/* ========================================
   TABLES
   ======================================== */

.table-container {
  overflow-x: auto;
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-200);
  border-radius: var(--border-radius-lg);
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table thead {
  background-color: var(--color-gray-50);
}

.table th {
  padding: 0.875rem 1rem;
  text-align: left;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--color-gray-700);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid var(--color-gray-200);
}

.table td {
  padding: 1rem;
  font-size: 0.875rem;
  color: var(--color-gray-800);
  border-bottom: 1px solid var(--color-gray-100);
}

.table tbody tr:last-child td {
  border-bottom: none;
}

.table tbody tr:hover {
  background-color: var(--color-gray-50);
}

/* ========================================
   UTILITY CLASSES
   ======================================== */

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.mb-sm { margin-bottom: var(--spacing-sm); }
.mb-md { margin-bottom: var(--spacing-md); }
.mb-lg { margin-bottom: var(--spacing-lg); }
.mb-xl { margin-bottom: var(--spacing-xl); }

.mt-sm { margin-top: var(--spacing-sm); }
.mt-md { margin-top: var(--spacing-md); }
.mt-lg { margin-top: var(--spacing-lg); }
.mt-xl { margin-top: var(--spacing-xl); }

.section-title {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--color-gray-500);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: var(--spacing-md);
}

.page-title {
  font-size: 1.875rem;
  font-weight: 700;
  color: var(--color-gray-800);
  margin: 0 0 var(--spacing-sm) 0;
}

.page-subtitle {
  font-size: 1.125rem;
  color: var(--color-gray-600);
  margin: 0 0 var(--spacing-xl) 0;
}

/* ========================================
   RESPONSIVE
   ======================================== */

@media (max-width: 768px) {
  .header {
    flex-direction: column;
    gap: var(--spacing-md);
  }

  .main-content,
  .main-content-wide {
    padding: var(--spacing-md);
  }

  .tab-nav {
    overflow-x: auto;
    padding-bottom: var(--spacing-xs);
  }

  .grid-2,
  .grid-3,
  .grid-4,
  .grid-6 {
    grid-template-columns: 1fr;
  }

  .footer-content {
    flex-direction: column;
    gap: var(--spacing-sm);
    text-align: center;
  }
}

/* ========================================
   PRINT STYLES
   ======================================== */

@media print {
  .header,
  .sub-header,
  .footer,
  .btn,
  .back-link {
    display: none !important;
  }

  .page-container {
    background-color: white;
  }

  .card {
    border: 1px solid #000;
    box-shadow: none;
    page-break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/portal.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;;6CAE6C;;AAE7C;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;;EAE9B,6BAA6B;EAC7B,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;;EAE5B,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;;EAEzB,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,uBAAuB;EACvB,yBAAyB;EACzB,iCAAiC;EACjC,mCAAmC;EACnC,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;;EAE/B,eAAe;EACf,iFAAiF;;EAEjF,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;;EAEnB,YAAY;EACZ,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;;EAExB,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;EAC3C,oDAAoD;EACpD,mDAAmD;AACrD;;AAEA;;6CAE6C;;AAE7C;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;6CAE6C;;AAE7C;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,4CAA4C;AAC9C;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;EAC5C,oCAAoC;EACpC,8CAA8C;EAC9C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;6CAE6C;;AAE7C;EACE,oCAAoC;EACpC,8CAA8C;EAC9C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;6CAE6C;;AAE7C;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;6CAE6C;;AAE7C;EACE,oCAAoC;EACpC,uCAAuC;EACvC,sCAAsC;EACtC,0BAA0B;EAC1B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;6CAE6C;;AAE7C;EACE,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;;6CAE6C;;AAE7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;;6CAE6C;;AAE7C;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;;;EAGE,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;EAC5B,oCAAoC;EACpC,uCAAuC;EACvC,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;EAC5C,sCAAsC;EACtC,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;;6CAE6C;;AAE7C;EACE,gBAAgB;EAChB,oCAAoC;EACpC,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;6CAE6C;;AAE7C;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,SAAS,gCAAgC,EAAE;AAC3C,SAAS,gCAAgC,EAAE;AAC3C,SAAS,gCAAgC,EAAE;AAC3C,SAAS,gCAAgC,EAAE;;AAE3C,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;;AAExC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;6CAE6C;;AAE7C;EACE;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;;6CAE6C;;AAE7C;EACE;;;;;IAKE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,wBAAwB;EAC1B;AACF","sourcesContent":["/* Maximal Dealer Portal - Design System */\n\n/* ========================================\n   CSS VARIABLES\n   ======================================== */\n\n:root {\n  /* Primary - Maximal Red */\n  --color-primary: #E31837;\n  --color-primary-hover: #C41530;\n  --color-primary-light: #FEE2E2;\n\n  /* Admin/Secondary - Purple */\n  --color-admin: #6366F1;\n  --color-admin-hover: #4F46E5;\n  --color-admin-light: #EEF2FF;\n\n  /* Neutrals */\n  --color-white: #FFFFFF;\n  --color-gray-50: #F9FAFB;\n  --color-gray-100: #F3F4F6;\n  --color-gray-200: #E5E7EB;\n  --color-gray-300: #D1D5DB;\n  --color-gray-400: #9CA3AF;\n  --color-gray-500: #6B7280;\n  --color-gray-600: #4B5563;\n  --color-gray-700: #374151;\n  --color-gray-800: #1F2937;\n  --color-gray-900: #111827;\n\n  /* Status Colors */\n  --color-success: #166534;\n  --color-success-bg: #DCFCE7;\n  --color-warning: #92400E;\n  --color-warning-bg: #FEF3C7;\n  --color-info: #1D4ED8;\n  --color-info-bg: #DBEAFE;\n  --color-error: #991B1B;\n  --color-error-bg: #FEE2E2;\n\n  /* Engine Type Badge Colors */\n  --badge-electric-bg: #DCFCE7;\n  --badge-electric-text: #166534;\n  --badge-diesel-bg: #F3F4F6;\n  --badge-diesel-text: #4B5563;\n  --badge-lpg-bg: #FEF3C7;\n  --badge-lpg-text: #92400E;\n  --badge-rough-terrain-bg: #F3E8FF;\n  --badge-rough-terrain-text: #7C3AED;\n  --badge-reach-bg: #DBEAFE;\n  --badge-reach-text: #1D4ED8;\n  --badge-warehouse-bg: #FCE7F3;\n  --badge-warehouse-text: #BE185D;\n\n  /* Typography */\n  --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  \n  /* Spacing */\n  --spacing-xs: 0.25rem;\n  --spacing-sm: 0.5rem;\n  --spacing-md: 1rem;\n  --spacing-lg: 1.5rem;\n  --spacing-xl: 2rem;\n  --spacing-2xl: 3rem;\n\n  /* Borders */\n  --border-radius-sm: 0.375rem;\n  --border-radius-md: 0.5rem;\n  --border-radius-lg: 0.75rem;\n  --border-radius-xl: 1rem;\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);\n  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);\n  --shadow-primary: 0 4px 12px rgba(227, 24, 55, 0.15);\n  --shadow-admin: 0 4px 12px rgba(99, 102, 241, 0.15);\n}\n\n/* ========================================\n   BASE STYLES\n   ======================================== */\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-family);\n  color: var(--color-gray-800);\n  background-color: var(--color-gray-50);\n  line-height: 1.5;\n  margin: 0;\n  padding: 0;\n}\n\n/* ========================================\n   LAYOUT\n   ======================================== */\n\n.page-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--color-gray-50);\n}\n\n.main-content {\n  flex: 1;\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n  padding: var(--spacing-xl) var(--spacing-lg);\n}\n\n.main-content-wide {\n  flex: 1;\n  max-width: 1400px;\n  width: 100%;\n  margin: 0 auto;\n  padding: var(--spacing-xl) var(--spacing-lg);\n}\n\n/* ========================================\n   HEADER\n   ======================================== */\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-md) var(--spacing-lg);\n  background-color: var(--color-white);\n  border-bottom: 1px solid var(--color-gray-200);\n  box-shadow: var(--shadow-sm);\n}\n\n.header-logo {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  text-decoration: none;\n  color: inherit;\n}\n\n.header-logo-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.header-logo-title {\n  color: var(--color-gray-800);\n  font-weight: 700;\n  font-size: 1.125rem;\n  line-height: 1.2;\n  letter-spacing: -0.01em;\n}\n\n.header-logo-subtitle {\n  color: var(--color-gray-500);\n  font-size: 0.75rem;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.header-nav {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-lg);\n}\n\n.header-link {\n  color: var(--color-gray-500);\n  text-decoration: none;\n  font-size: 0.875rem;\n  transition: color 0.2s;\n}\n\n.header-link:hover {\n  color: var(--color-gray-900);\n}\n\n.header-user {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n}\n\n.header-user-info {\n  text-align: right;\n}\n\n.header-user-name {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--color-gray-800);\n  margin: 0;\n}\n\n.header-user-role {\n  font-size: 0.75rem;\n  color: var(--color-primary);\n  font-weight: 500;\n  margin: 0;\n}\n\n.header-user-role.admin {\n  color: var(--color-admin);\n}\n\n.header-avatar {\n  width: 2.25rem;\n  height: 2.25rem;\n  border-radius: 50%;\n  background-color: var(--color-primary);\n  color: var(--color-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n/* ========================================\n   SUB-HEADER / TABS\n   ======================================== */\n\n.sub-header {\n  background-color: var(--color-white);\n  border-bottom: 1px solid var(--color-gray-200);\n  padding: 0 var(--spacing-lg);\n}\n\n.tab-nav {\n  display: flex;\n  gap: var(--spacing-lg);\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.tab-link {\n  padding: var(--spacing-md) var(--spacing-sm);\n  color: var(--color-gray-600);\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 0.875rem;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s;\n}\n\n.tab-link:hover {\n  color: var(--color-gray-900);\n  border-bottom-color: var(--color-gray-300);\n}\n\n.tab-link.active {\n  color: var(--color-primary);\n  border-bottom-color: var(--color-primary);\n}\n\n.back-link {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  color: var(--color-gray-600);\n  text-decoration: none;\n  font-size: 0.875rem;\n  margin-bottom: var(--spacing-md);\n  transition: color 0.2s;\n}\n\n.back-link:hover {\n  color: var(--color-primary);\n}\n\n/* ========================================\n   FOOTER\n   ======================================== */\n\n.footer {\n  background-color: var(--color-white);\n  border-top: 1px solid var(--color-gray-200);\n  padding: var(--spacing-lg);\n}\n\n.footer-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.footer-text {\n  color: var(--color-gray-500);\n  font-size: 0.875rem;\n}\n\n.footer-link {\n  color: var(--color-gray-500);\n  text-decoration: none;\n  font-size: 0.875rem;\n  transition: color 0.2s;\n}\n\n.footer-link:hover {\n  color: var(--color-gray-900);\n}\n\n/* ========================================\n   CARDS\n   ======================================== */\n\n.card {\n  background-color: var(--color-white);\n  border: 1px solid var(--color-gray-200);\n  border-radius: var(--border-radius-xl);\n  padding: var(--spacing-lg);\n  box-shadow: var(--shadow-sm);\n  transition: all 0.2s;\n}\n\n.card:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.card.tile {\n  display: block;\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n}\n\n.card.tile:hover {\n  border-color: var(--color-primary);\n  box-shadow: var(--shadow-primary);\n  transform: translateY(-2px);\n}\n\n.card-admin.tile:hover {\n  border-color: var(--color-admin);\n  box-shadow: var(--shadow-admin);\n}\n\n/* ========================================\n   TILES (Dashboard)\n   ======================================== */\n\n.tile-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: var(--spacing-md);\n}\n\n.tile-icon {\n  width: 3rem;\n  height: 3rem;\n  border-radius: var(--border-radius-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-primary);\n  background-color: var(--color-primary-light);\n}\n\n.tile-icon.primary {\n  color: var(--color-primary);\n  background-color: var(--color-primary-light);\n}\n\n.tile-icon.admin {\n  color: var(--color-admin);\n  background-color: var(--color-admin-light);\n}\n\n.tile-icon svg {\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n.tile-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--color-gray-800);\n  margin: 0 0 var(--spacing-xs) 0;\n  transition: color 0.2s;\n}\n\n.card.tile:hover .tile-title {\n  color: var(--color-primary);\n}\n\n.card-admin.tile:hover .tile-title {\n  color: var(--color-admin);\n}\n\n.tile-description {\n  font-size: 0.875rem;\n  color: var(--color-gray-600);\n  margin: 0 0 var(--spacing-md) 0;\n  line-height: 1.5;\n}\n\n.tile-footer {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--color-primary);\n}\n\n.tile-footer svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n/* ========================================\n   BADGES\n   ======================================== */\n\n.badge {\n  display: inline-block;\n  padding: 0.25rem 0.625rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.badge-success {\n  background-color: var(--color-success-bg);\n  color: var(--color-success);\n}\n\n.badge-warning {\n  background-color: var(--color-warning-bg);\n  color: var(--color-warning);\n}\n\n.badge-info {\n  background-color: var(--color-info-bg);\n  color: var(--color-info);\n}\n\n.badge-error {\n  background-color: var(--color-error-bg);\n  color: var(--color-error);\n}\n\n.badge-purple {\n  background-color: #F3E8FF;\n  color: #7C3AED;\n}\n\n.badge-pink {\n  background-color: #FCE7F3;\n  color: #BE185D;\n}\n\n.badge-gray {\n  background-color: var(--color-gray-100);\n  color: var(--color-gray-700);\n}\n\n/* Engine Type Badges */\n.badge-electric {\n  background-color: var(--badge-electric-bg);\n  color: var(--badge-electric-text);\n}\n\n.badge-diesel {\n  background-color: var(--badge-diesel-bg);\n  color: var(--badge-diesel-text);\n}\n\n.badge-lpg {\n  background-color: var(--badge-lpg-bg);\n  color: var(--badge-lpg-text);\n}\n\n.badge-rough-terrain {\n  background-color: var(--badge-rough-terrain-bg);\n  color: var(--badge-rough-terrain-text);\n}\n\n.badge-reach {\n  background-color: var(--badge-reach-bg);\n  color: var(--badge-reach-text);\n}\n\n.badge-warehouse {\n  background-color: var(--badge-warehouse-bg);\n  color: var(--badge-warehouse-text);\n}\n\n/* ========================================\n   BUTTONS\n   ======================================== */\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-xs);\n  padding: 0.625rem 1.25rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1;\n  border-radius: var(--border-radius-md);\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-decoration: none;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background-color: var(--color-primary);\n  color: var(--color-white);\n  border-color: var(--color-primary);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: var(--color-primary-hover);\n  border-color: var(--color-primary-hover);\n}\n\n.btn-secondary {\n  background-color: var(--color-white);\n  color: var(--color-gray-700);\n  border-color: var(--color-gray-300);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: var(--color-gray-50);\n  border-color: var(--color-gray-400);\n}\n\n.btn-ghost {\n  background-color: transparent;\n  color: var(--color-gray-600);\n  border-color: transparent;\n}\n\n.btn-ghost:hover:not(:disabled) {\n  background-color: var(--color-gray-100);\n  color: var(--color-gray-900);\n}\n\n.btn-admin {\n  background-color: var(--color-admin);\n  color: var(--color-white);\n  border-color: var(--color-admin);\n}\n\n.btn-admin:hover:not(:disabled) {\n  background-color: var(--color-admin-hover);\n  border-color: var(--color-admin-hover);\n}\n\n.btn-icon {\n  padding: 0.5rem;\n  border-radius: var(--border-radius-md);\n}\n\n/* ========================================\n   FORMS\n   ======================================== */\n\n.form-group {\n  margin-bottom: var(--spacing-lg);\n}\n\n.form-label {\n  display: block;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--color-gray-700);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: var(--spacing-xs);\n}\n\n.form-input,\n.form-select,\n.form-textarea {\n  width: 100%;\n  padding: 0.625rem 0.875rem;\n  font-size: 0.875rem;\n  color: var(--color-gray-800);\n  background-color: var(--color-white);\n  border: 1px solid var(--color-gray-300);\n  border-radius: var(--border-radius-md);\n  transition: border-color 0.2s;\n}\n\n.form-input:focus,\n.form-select:focus,\n.form-textarea:focus {\n  outline: none;\n  border-color: var(--color-primary);\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.form-error {\n  color: var(--color-error);\n  font-size: 0.75rem;\n  margin-top: var(--spacing-xs);\n}\n\n/* ========================================\n   GRID LAYOUTS\n   ======================================== */\n\n.grid-2 {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: var(--spacing-lg);\n}\n\n.grid-3 {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: var(--spacing-lg);\n}\n\n.grid-4 {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: var(--spacing-lg);\n}\n\n.grid-6 {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: var(--spacing-md);\n}\n\n@media (min-width: 768px) {\n  .grid-2 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .grid-3 {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  \n  .grid-4 {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  \n  .grid-6 {\n    grid-template-columns: repeat(6, 1fr);\n  }\n}\n\n/* ========================================\n   ACCORDION (Forklift Ranges)\n   ======================================== */\n\n.accordion {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n}\n\n.accordion-item {\n  background-color: var(--color-white);\n  border: 1px solid var(--color-gray-200);\n  border-radius: var(--border-radius-lg);\n  overflow: hidden;\n}\n\n.accordion-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-md) var(--spacing-lg);\n  background-color: var(--color-gray-50);\n  cursor: pointer;\n  transition: background-color 0.2s;\n  border: none;\n  width: 100%;\n  text-align: left;\n}\n\n.accordion-header:hover {\n  background-color: var(--color-gray-100);\n}\n\n.accordion-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--color-gray-800);\n  margin: 0;\n}\n\n.accordion-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n  color: var(--color-gray-500);\n  transition: transform 0.2s;\n}\n\n.accordion-header.expanded .accordion-icon {\n  transform: rotate(180deg);\n}\n\n.accordion-content {\n  padding: var(--spacing-lg);\n}\n\n.accordion-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-md);\n  border-bottom: 1px solid var(--color-gray-100);\n}\n\n.accordion-row:last-child {\n  border-bottom: none;\n}\n\n.accordion-model-info {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n}\n\n.accordion-model-name {\n  font-weight: 600;\n  color: var(--color-gray-800);\n}\n\n.accordion-model-specs {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  color: var(--color-gray-600);\n  font-size: 0.875rem;\n}\n\n/* ========================================\n   TABLES\n   ======================================== */\n\n.table-container {\n  overflow-x: auto;\n  background-color: var(--color-white);\n  border: 1px solid var(--color-gray-200);\n  border-radius: var(--border-radius-lg);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table thead {\n  background-color: var(--color-gray-50);\n}\n\n.table th {\n  padding: 0.875rem 1rem;\n  text-align: left;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--color-gray-700);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid var(--color-gray-200);\n}\n\n.table td {\n  padding: 1rem;\n  font-size: 0.875rem;\n  color: var(--color-gray-800);\n  border-bottom: 1px solid var(--color-gray-100);\n}\n\n.table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.table tbody tr:hover {\n  background-color: var(--color-gray-50);\n}\n\n/* ========================================\n   UTILITY CLASSES\n   ======================================== */\n\n.text-center {\n  text-align: center;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.mb-sm { margin-bottom: var(--spacing-sm); }\n.mb-md { margin-bottom: var(--spacing-md); }\n.mb-lg { margin-bottom: var(--spacing-lg); }\n.mb-xl { margin-bottom: var(--spacing-xl); }\n\n.mt-sm { margin-top: var(--spacing-sm); }\n.mt-md { margin-top: var(--spacing-md); }\n.mt-lg { margin-top: var(--spacing-lg); }\n.mt-xl { margin-top: var(--spacing-xl); }\n\n.section-title {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--color-gray-500);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin-bottom: var(--spacing-md);\n}\n\n.page-title {\n  font-size: 1.875rem;\n  font-weight: 700;\n  color: var(--color-gray-800);\n  margin: 0 0 var(--spacing-sm) 0;\n}\n\n.page-subtitle {\n  font-size: 1.125rem;\n  color: var(--color-gray-600);\n  margin: 0 0 var(--spacing-xl) 0;\n}\n\n/* ========================================\n   RESPONSIVE\n   ======================================== */\n\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    gap: var(--spacing-md);\n  }\n\n  .main-content,\n  .main-content-wide {\n    padding: var(--spacing-md);\n  }\n\n  .tab-nav {\n    overflow-x: auto;\n    padding-bottom: var(--spacing-xs);\n  }\n\n  .grid-2,\n  .grid-3,\n  .grid-4,\n  .grid-6 {\n    grid-template-columns: 1fr;\n  }\n\n  .footer-content {\n    flex-direction: column;\n    gap: var(--spacing-sm);\n    text-align: center;\n  }\n}\n\n/* ========================================\n   PRINT STYLES\n   ======================================== */\n\n@media print {\n  .header,\n  .sub-header,\n  .footer,\n  .btn,\n  .back-link {\n    display: none !important;\n  }\n\n  .page-container {\n    background-color: white;\n  }\n\n  .card {\n    border: 1px solid #000;\n    box-shadow: none;\n    page-break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
